export default function formatBytes(bytes: number, precision = 2): string {
  if (bytes === 0) {
    return '0 Byte';
  }

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(precision))} ${sizes[i]}`;
}
